//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Cell',
  props: {
    title: {
      required: true,
      type: String
    },
    value: {
      required: false,
      type: [String, Number]
    },
    isLink: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Cell/Cell.vue